import Vue, { CreateElement } from 'src/vue'
import { Component, Watch } from 'vue-property-decorator'

import { Input } from 'src/elements/input/input'
import { ErrorScreen } from 'src/components/error-screen/error-screen'
import { Link } from 'src/elements/link/link'
import ApiClient, { ApiCallError } from '@src/lib/api_client'
import TrainingPlan from '@src/data/training-plan'
import { track } from '@src/util/functions'
import { TrainingPlanService } from '@src/service/training-plan'
import { TrainingPlanFilters } from '@src/state/store'
import { defaultTrainingPlanFilters } from '@src/state/dafaults'
import { TrainingCardInfo } from '@src/components/card/training-card/training-card-info/training-card-info'
import { Pagination } from '@src/elements/pagination/pagination'
import { DEFAULT_PAGE_SIZE } from '@src/util/constants'
import { Loader } from '@src/components/loading-screen/loader/loader'

import './training-plans.sass'
import Member from '@src/data/member'

@Component({
  computed: {
    trainingPlansFilters () {
      return this.$store.state.trainingPlansFilters
    },
    member () {
      return this.$store.state.selectedMember || this.$store.state.memberProfile
    }
  }
})
export class TrainingPlans extends Vue {
  trainingPlansFilters: TrainingPlanFilters
  apiClient: ApiClient = new ApiClient()
  error: ApiCallError | null = null

  trainingPlans: TrainingPlan[] = []
  updateNameFilterTimeout

  currentPage = 1
  totalPages: number = 0
  loading = true
  member: Member | null

  constructor () {
    super()
    track('/content/trainingplan')
  }

  created () {
    return this.initialize()
  }

  initialize () {
    return this.loadPlans()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MY_CONTENT')} - ${this.$root.$t('PAGE.CONTENT.TRAINING_PLAN.TAB_NAME')}`
  }

  filterByName (value: string) {
    // Delaying the update of name filer to avoid api calls at every letter.
    if (this.updateNameFilterTimeout) clearTimeout(this.updateNameFilterTimeout)
    this.updateNameFilterTimeout = setTimeout(() => {
      if (this.trainingPlans.length) this.trainingPlans = []
      this.$store.dispatch('filterTrainingPlans', { name: value })
    }, 400)
  }

  filterByType (value: string) {
    this.trainingPlans = []
    return this.$store.dispatch('filterTrainingPlans', { type: value })
  }

  resetFilters () {
    this.trainingPlans = []
    return this.$store.dispatch('filterTrainingPlans', defaultTrainingPlanFilters())
  }

  @Watch('trainingPlansFilters')
  filtersChanged () {
    return this.changePage(1)
  }

  changePage (page) {
    this.currentPage = page
    return this.loadPlans()
  }

  render (h: CreateElement) {
    // let typeFilterLabel = this.trainingPlansFilters.type === undefined ? this.$t('ALL') : this.$t(`PAGE.CONTENT.TRAINING_PLAN.${{
    //   'home': 'HOME_PLANS',
    //   'tracked': 'TRACKED'
    // }[`${this.trainingPlansFilters.type}`]}`)

    return <div class='training-plan-wrapper'>
      <div class='row'>
        <Input search={true} ref='nameFilter' valueChanged={this.filterByName} placeholder={this.$t('SEARCH_PLACEHOLDER')}
               value={this.trainingPlansFilters.name} class='name-filter'/>
        {/*Hide home workouts*/}
        {/*<Select filter={true} ref='typeFilter' value={typeFilterLabel}>*/}
        {/*  <OptionGroup>*/}
        {/*    <Option type='single-option' value={'all'} label={this.$t('ALL')}*/}
        {/*            selected={this.trainingPlansFilters.type === undefined} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.length.toString()} />*/}
        {/*    <Option type='single-option' value={'home'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.HOME_PLANS')}*/}
        {/*            selected={this.trainingPlansFilters.type === 'home'} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.filter((w) => w.trainingPlanType === 'home').length.toString()} />*/}
        {/*    <Option type='single-option' value={'tracked'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TRACKED')}*/}
        {/*            selected={this.trainingPlansFilters.type === 'tracked'} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.filter((w) => w.trainingPlanType === 'tracked').length.toString()} />*/}
        {/*  </OptionGroup>*/}
        {/*</Select>*/}
      </div>
      { this.renderContent(h) }
    </div>
  }

  renderContent (h) {
    if (this.loading) return <Loader />
    if (!this.trainingPlans.length) return this.getErrorScreen(h)
    return <div class='list-wrapper'>
      <div class='plan-list'>
        {this.trainingPlans.map((item) => <TrainingCardInfo type='view' training={item} updateCallback={this.updateCallback} key={item.id}/>)}
      </div>
      <Pagination changePage={this.changePage}
                  currentPage={this.currentPage}
                  pageSize={DEFAULT_PAGE_SIZE}
                  total={this.totalPages * DEFAULT_PAGE_SIZE} />
    </div>
  }

  updateCallback () {
    // when last page is empty go to prev page
    const lastPageEmpty = this.trainingPlans.length === 1 && this.currentPage > 1
    return this.changePage(lastPageEmpty ? this.currentPage - 1 : this.currentPage)
  }

  getErrorScreen (h: CreateElement) {
    if (this.error) {
      return <ErrorScreen title={this.$t('PAGE.CONTENT.TRAINING_PLAN.REQUEST_ERROR')}
                          message={this.$t(this.error.messageKey)}>
        <Link align='center' click={() => {
          this.error = null
          return this.resetFilters()
        }} label={this.$t('TRY_AGAIN')} variant='colored' />
      </ErrorScreen>
    }
    if (!this.trainingPlans.length && this.filtersApplied()) {
      return <ErrorScreen
        message={this.trainingPlansFilters.name ? this.$t('PAGE.CONTENT.TRAINING_PLAN.NOT_FOUND.FILTER.NAME', { query: this.trainingPlansFilters.name }) : this.$t('PAGE.CONTENT.TRAINING_PLAN.NOT_FOUND.FILTER.GENERIC')}>
        <Link variant='colored' align='center' click={this.resetFilters}
              label={this.$t('PAGE.CONTENT.TRAINING_PLAN.RESET_FILTERS')} />
      </ErrorScreen>
    }
    return <ErrorScreen message={this.$t('PAGE.CONTENT.TRAINING_PLAN.NO_PLANS')} />
  }

  filtersApplied (): boolean {
    return JSON.stringify(this.trainingPlansFilters) !== JSON.stringify(defaultTrainingPlanFilters())
  }

  loadPlans () {
    this.loading = true
    return new TrainingPlanService().getTrainingPlans(this.currentPage, DEFAULT_PAGE_SIZE, 'club', this.trainingPlansFilters.name)
      .then(response => {
        this.trainingPlans = response.trainingPlans
        this.totalPages = response.totalPages
      }).catch(error => {
        this.error = error
        return Promise.reject(error)
      })
      .finally(() => this.loading = false)
  }
}
